import React, { useState, useEffect } from 'react';
import axios from 'axios';

const PopupManager = () => {
  const [popups, setPopups] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [formData, setFormData] = useState({
    link_url: '',
    is_active: true
  });
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    fetchPopups();
  }, []);

  const fetchPopups = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.get('/api/popups', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPopups(response.data);
    } catch (error) {
      console.error('Error fetching popups:', error);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!imageFile && !editingItem) {
      alert('Lütfen bir görsel seçin');
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem('adminToken');
      const formDataToSend = new FormData();

      if (imageFile) {
        formDataToSend.append('image', imageFile);
      }

      if (formData.link_url) {
        formDataToSend.append('link_url', formData.link_url);
      }

      if (editingItem) {
        await axios.put(`/api/popups/${editingItem.id}`, formDataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
      } else {
        await axios.post('/api/popups', formDataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
      }

      alert('Popup başarıyla kaydedildi!');
      fetchPopups();
      resetForm();
    } catch (error) {
      console.error('Error saving popup:', error);
      alert('Kaydetme hatası: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({
      link_url: item.link_url || '',
      is_active: item.is_active
    });
    setPreview(item.image_url && item.image_url.startsWith('http') ? item.image_url : item.image_url || '');
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu popup\'ı silmek istediğinizden emin misiniz?')) {
      return;
    }

    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`/api/popups/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchPopups();
    } catch (error) {
      console.error('Error deleting popup:', error);
      alert('Silme hatası');
    }
  };

  const handleToggleActive = async (popup) => {
    try {
      const token = localStorage.getItem('adminToken');
      const formDataToSend = new FormData();
      formDataToSend.append('link_url', popup.link_url || '');
      formDataToSend.append('is_active', (!popup.is_active).toString());

      await axios.put(`/api/popups/${popup.id}`, formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      fetchPopups();
    } catch (error) {
      console.error('Error toggling popup:', error);
      alert('Durum değiştirme hatası');
    }
  };

  const resetForm = () => {
    setFormData({
      link_url: '',
      is_active: true
    });
    setImageFile(null);
    setPreview(null);
    setEditingItem(null);
    setShowForm(false);
  };

  return (
    <div className="bg-gradient-card rounded-xl p-6 border border-gold/30">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gold">Popup Yönetimi</h2>
        <button
          onClick={() => setShowForm(!showForm)}
          className="bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold px-4 py-2 rounded-lg transition-all duration-300 shadow-gold"
        >
          {showForm ? 'İptal' : '+ Yeni Popup'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="bg-navy-700 p-6 rounded-lg mb-6 space-y-4">
          {/* Preview */}
          {preview && (
            <div className="flex flex-col items-center gap-4 p-6 bg-navy-800 rounded-lg border border-gold/20">
              <h3 className="text-white font-semibold">Görsel Önizleme</h3>
              <div className="bg-white/10 p-4 rounded-lg">
                <img
                  src={preview}
                  alt="Popup preview"
                  className="max-h-64 max-w-full object-contain"
                  onError={() => setPreview(null)}
                />
              </div>
              <p className="text-white/60 text-sm text-center">
                Bu görsel popup olarak gösterilecektir
              </p>
            </div>
          )}

          {/* Image Input */}
          <div>
            <label className="block text-white mb-2">
              Popup Görseli {!editingItem && '*'}
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
              required={!editingItem}
            />
            <p className="text-white/60 text-xs mt-1">
              Popup boyutu görselinizin boyutuna göre ayarlanacaktır
            </p>
          </div>

          {/* Link URL */}
          <div>
            <label className="block text-white mb-2">Hedef URL (Opsiyonel)</label>
            <input
              type="url"
              value={formData.link_url}
              onChange={(e) => setFormData({ ...formData, link_url: e.target.value })}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
              placeholder="https://example.com"
            />
            <p className="text-white/60 text-xs mt-1">
              Görsele tıklandığında yönlendirilecek URL
            </p>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold py-2 px-4 rounded-lg transition-all duration-300 shadow-gold disabled:opacity-50"
          >
            {loading ? 'Kaydediliyor...' : (editingItem ? 'Güncelle' : 'Ekle')}
          </button>
        </form>
      )}

      <div className="space-y-4">
        {popups.map((popup) => (
          <div key={popup.id} className="bg-navy-700 p-4 rounded-lg flex items-center gap-4">
            {popup.image_url && (
              <img
                src={popup.image_url && popup.image_url.startsWith('http') ? popup.image_url : popup.image_url || ''}
                alt="Popup"
                className="w-32 h-32 object-contain rounded bg-white/5"
              />
            )}
            <div className="flex-1">
              <h3 className="text-white font-bold flex items-center gap-2">
                Popup #{popup.id}
                {popup.is_active === 1 && (
                  <span className="bg-gradient-to-r from-gold to-yellow-500 text-navy-900 text-xs px-2 py-1 rounded-full font-semibold">
                    Aktif
                  </span>
                )}
              </h3>
              <p className="text-white/60 text-sm">Link: {popup.link_url || 'Yok'}</p>
              <p className="text-white/60 text-sm">Durum: {popup.is_active ? 'Aktif' : 'Pasif'}</p>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => handleToggleActive(popup)}
                className={`${popup.is_active ? 'bg-yellow-500 hover:bg-yellow-600' : 'bg-gray-500 hover:bg-gray-600'} text-white px-3 py-1 rounded transition-colors`}
              >
                {popup.is_active ? 'Pasif Yap' : 'Aktif Yap'}
              </button>
              <button
                onClick={() => handleEdit(popup)}
                className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded transition-colors"
              >
                Düzenle
              </button>
              <button
                onClick={() => handleDelete(popup.id)}
                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded transition-colors"
              >
                Sil
              </button>
            </div>
          </div>
        ))}

        {popups.length === 0 && (
          <p className="text-center text-white/60 py-8">Henüz popup eklenmedi</p>
        )}
      </div>
    </div>
  );
};

export default PopupManager;
